import type { MigrationItem } from '../../components/DeleteEntityModals/components/ListItemCard';

const hasValidOffice = (migrationValue: MigrationItem): boolean =>
  migrationValue.targetOfficeId != null;

export default hasValidOffice;
